import { render, staticRenderFns } from "./ColorsLandingPage.vue?vue&type=template&id=62c62efc"
import script from "./ColorsLandingPage.vue?vue&type=script&lang=js"
export * from "./ColorsLandingPage.vue?vue&type=script&lang=js"
import style0 from "./ColorsLandingPage.vue?vue&type=style&index=0&id=62c62efc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports